import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { UserInterface } from '../../common/types/interfaces'

const userFromStorage = localStorage.getItem('currentUser')

const initialState: { user: UserInterface | undefined } = {
  user: userFromStorage ? JSON.parse(userFromStorage) : null,
}

export const currentUserSlice = createSlice({
  name: 'current-user',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<UserInterface | undefined>) => {
      state.user = { ...action.payload }
    },
    resetCurrentUser: (state) => {
      state.user = undefined
    },
  },
})

export const { setCurrentUser } = currentUserSlice.actions
export const { resetCurrentUser } = currentUserSlice.actions
export const selectCurrentUser = (state: RootState) => state.currentUser.user

export default currentUserSlice.reducer
